export default class Modal {

    constructor() {
        this.settings = {
            $modal : $(".js-modal"),
            $modalTrigger : $(".js-modal-trigger"),
            $modalClose : $(".js-modal-close")
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if (this.settings.$modalTrigger != null && this.settings.$modal != null) {

            this.settings.$modalTrigger.on('click', function() {

                let id = $(this).data( "modal-trigger" );
                $('#'+id).toggleClass('hidden');

            });

            this.settings.$modalClose.on('click', function() {

                let parentId = $(this).closest('.js-modal').attr('id');
                $('#'+parentId).toggleClass('hidden');

            });

        }

    }
};

new Modal();